import { call, put, takeLatest } from 'redux-saga/effects';

import * as blogActions from './blogActions.js';
import { updateBlogApiCall } from './blogAPI.js';

function* updateBlogSaga({ payload }) {
  try {
    const { data } = yield call(updateBlogApiCall, payload);
    yield put(blogActions.blogUpdateStore(data));
  } catch (error) {
    yield put(blogActions.blogUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* blogWatcher() {
  yield takeLatest(blogActions.blogUpdateRequest.type, updateBlogSaga);
}
